// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Hm3vu","skeleton-progress":"JtTAV"};